export default { sha: '42e35f63b117baf8fdf30d754c12cc70249b7a9d', buildNumber: 'undefined' }
